// Helpers for Full Name (Имя Фамилия) input.
// Goal: forbid digits and special symbols; allow letters (RU/EN), spaces, hyphen and apostrophe.

const DISALLOWED_RE = /[^A-Za-zА-Яа-яЁё\s\-'’]/g; // \u2019 = ’

export function sanitizeFullNameInput(value) {
  let s = String(value ?? '');
  // remove anything that is not allowed
  s = s.replace(DISALLOWED_RE, '');
  // collapse whitespace
  s = s.replace(/\s+/g, ' ');
  return s;
}

export function validateFullName(value) {
  const raw = String(value ?? '');
  const s = raw.trim().replace(/\s+/g, ' ');

  if (s.length < 3) return 'Введите имя и фамилию';

  // if user entered forbidden chars (digits/special) -> error
  const cleaned = sanitizeFullNameInput(s);
  if (cleaned !== s) return 'Только буквы, пробелы и дефис';

  const parts = s.split(' ').filter(Boolean);
  if (parts.length < 2) return 'Укажите имя и фамилию';

  // each part should start with a letter and be at least 2 symbols (allow hyphen/apostrophe inside)
  const partOk = (p) => /^[A-Za-zА-Яа-яЁё][A-Za-zА-Яа-яЁё'’-]{0,}$/.test(p) && p.length >= 2;
  if (!parts.every(partOk)) return 'Проверьте корректность ФИО';

  return '';
}
